import { EditorEligibilityRule } from './editor-eligibility-rule.model';


export class EditorEligibilityRuleHasBookingOption extends EditorEligibilityRule {
  className = 'HasBookingOption';
  operatorName = 'hasBookingOption';

  bookingItem: string;
  bookingOptions: string[];
  // states: string[];
  stateNamesString: string;
  metadata: string[];

  constructor(obj?: any) {
    super({
      id: obj?.id ?? null
    });
    this.bookingItem = obj?.bookingItem ?? null;
    this.bookingOptions = obj?.bookingOptions ?? [];
    // this.states = obj?.states ?? [];
    this.stateNamesString = obj?.stateNamesString ?? '';
    this.metadata = obj?.metadata ?? [];
  }

  static matchesTypeOfLegacySerializedValues(legacyEligibilityRules: any) {
    return legacyEligibilityRules?.args?.[0]?.args?.[0]?.op === 'fetchFromES'
      && legacyEligibilityRules?.args?.[0]?.args?.[0]?.options?.type === 'booking'
      && legacyEligibilityRules?.args?.[0]?.args?.[0]?.options?.filter?.bookingItem !== undefined
      && legacyEligibilityRules?.args?.[0]?.args?.[0]?.options?.filter?.bookingOption !== undefined;
  }

  static getFromLegacySerializedValues(legacyEligibilityRules: any) {
    if (typeof(legacyEligibilityRules.args[0].args[0].options.filter.bookingItem) !== 'string') {
      throw new Error('"has booking option" rule has a non-string booking item.');
    }

    let states = legacyEligibilityRules.args[0].args[0].options.filter?.['es_extra.stateName'];
    if (typeof(states) === 'string') {
      states = [states];
    }

    const metadata = Object.keys(legacyEligibilityRules.args[0].args[0].options.filter)
      .filter(key => key.substring(0, 8) === 'metadata')
      .map(key => key.substring(9));

    return new this({
      bookingItem: legacyEligibilityRules.args[0].args[0].options.filter.bookingItem,
      bookingOptions: typeof(legacyEligibilityRules.args[0].args[0].options.filter.bookingOption) === 'string'
      ? [legacyEligibilityRules.args[0].args[0].options.filter.bookingOption]
      : legacyEligibilityRules.args[0].args[0].options.filter.bookingOption,
      stateNamesString: states === undefined ? null : states.join(', '),
      metadata
    });
  }

  static getFromSerializedValues(serializedValues: any) {
    return new this({
      bookingItem: serializedValues.bookingItem,
      bookingOptions: serializedValues.bookingOptions,
      stateNamesString: serializedValues.states.join(', '),
      metadata: serializedValues.metadata
    });
  }

  static getEmptyControlConfig(): { [key: string]: any; } {
    return {
      bookingItem: [{ value: null, disabled: true }],
      bookingOptions: [{ value: [], disabled: true }],
      // states: [{ value: [], disabled: true }],
      stateNamesString: [{ value: '', disabled: true }, EditorEligibilityRuleHasBookingOption.getStateNamesStringControlOptions()],
      metadata: [{ value: [], disabled: true }]
    };
  }

  static getStateNamesStringControlOptions(): any {
    return {
      validators: [],
      updateOn: 'blur'
    };
  }

  createCopy(): EditorEligibilityRuleHasBookingOption {
    return new EditorEligibilityRuleHasBookingOption({
      id: this.id,
      bookingItem: this.bookingItem,
      bookingOptions: [...this.bookingOptions],
      // states: [...this.states],
      stateNamesString: this.stateNamesString,
      metadata: [...this.metadata]
    });
  }

  getBookingItemName(bookingItemNames: { id: string, name: string }[]): string {
    if (this.bookingItem === null) { return ''; }
    return bookingItemNames
      .find(bookingItemName => bookingItemName.id === this.bookingItem)?.name ?? 'Not valid';
  }

  getBookingOptionsAsString(bookingOptionNames: { id: string, name: string }[]): string {
    if (this.bookingOptions.length === 0) { return ''; }
    return this.bookingOptions
      .map(bookingOption =>
        bookingOptionNames.find(bookingOptionName => bookingOptionName.id === bookingOption) ?? { id: bookingOption, name: $localize `Not valid` }
      )
      .map(bookingOptionName => bookingOptionName.name)
      .join(', ');
  }
/*
  getBookingStatesAsString(bookingStateNames: { id: string, name: string }[]): string {
    if (this.states.length === 0) { return ''; }
    return this.states
      .map(state =>
        bookingStateNames.find(bookingStateName => bookingStateName.id === state) ?? { id: state, name: $localize `Not valid` }
      )
      .map(bookingStateName => bookingStateName.name)
      .join(', ');
  }
*/
  getBookingMetadataAsString(bookingMetadataNames: { id: string, name: string }[]): string {
    if (this.metadata.length === 0) { return ''; }
    return this.metadata
      .map(metadata =>
        bookingMetadataNames.find(bookingMetadataName => bookingMetadataName.id === metadata) ?? { id: metadata, name: $localize `Not valid` }
      )
      .map(bookingMetadataName => bookingMetadataName.name)
      .join(', ');
  }

  getControlsConfig(): { [key: string]: any; } {
    return {
      bookingItem: [this.bookingItem],
      bookingOptions: [this.bookingOptions],
      // states: [this.states],
      stateNamesString: [this.stateNamesString, EditorEligibilityRuleHasBookingOption.getStateNamesStringControlOptions()],
      metadata: [this.metadata],
    };
  }

  getSerializedValues(): any {
    return {
      bookingItem: this.bookingItem,
      bookingOptions: this.bookingOptions,
      // states: this.states,
      states: this.stateNamesString === '' ? [] : this.stateNamesString.split(',').map(itm => itm.trim().toUpperCase()),
      metadata: this.metadata
    };
  }
}
